const systems: { [details: string]: string; } = {
  clientId: 'guestme-client',
  secretKey: '9ACepV68zJ2x3AtN',
  yandexMapAPIKey: '8771c9d7-aa10-4f5d-afa5-e7c18bc1c474',
};

export default systems;
